/**
 * @file This file reexports the client instrumentation from the base site.
 */
export * from '@/base/instrumentation-client';
